import letThemChooseUtil from '@lib/util/let-them-choose-util';

//this function will delete and replace with util function
export const getBusinessName = (
  card_program: string | undefined,
  business_name: string | undefined,
  hasA: boolean = false,
  isYour: boolean = false,
) => {
  return letThemChooseUtil.getBusinessName(card_program, business_name, hasA, isYour);
};